import '.ao{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.ib{min-height:200px;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.at{justify-content:center;}.ssr-plugin'
import '.ag{align-items:flex-start;}.ssr-plugin'
import '.ed{padding:2rem;}.ssr-plugin'
import '.ek{background:var(--palette-white);}.ssr-plugin'
import '.bg{overflow:hidden;}.ssr-plugin'
import '.bs{position:absolute;}.ssr-plugin'
import '.ji{top:50%;}.ssr-plugin'
import '.jj{right:1rem;}.ssr-plugin'
import '.jk{transform:translateY(-50%);}.ssr-plugin'
import '.jl{width:120px;}.ssr-plugin'
import '.jm{height:120px;}.ssr-plugin'
import '.jn{z-index:0;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.h1{z-index:1;}.ssr-plugin'
import '.u{gap:0.5rem;}.ssr-plugin'
import '.jo{max-width:calc(100% - 140px);}.ssr-plugin'
import '.jp{font-size:4rem;}.ssr-plugin'
import '.cl{font-weight:700;}.ssr-plugin'
import '.jq{line-height:100%;}.ssr-plugin'
import '.gx{margin:0px;}.ssr-plugin'
import '.a3{color:var(--brand-secondary);}.ssr-plugin'
import '.a4{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="ao n ib d e at ag ed ek bg"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="bs ji jj jk jl jm jn d t at"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="ao h1 d e ag u jo"
      >
        <div className="jp cl jq gx a3 a4"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
